/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../axios';

const initialState = {
	emailTemplates: { loading: false, list: [] },
	selectedTemplate: { loading: false, template: null },
	templateVariables: { loading: false, catalog: [] },
};

export const getAllEmailTemplates = createAsyncThunk('emailTemplates/getAll', async () => {
	try {
		const response = await axiosInstance.get('/email-templates');
		return response.data;
	} catch (error) {
		throw new Error(error.response?.data?.message || 'Error fetching templates');
	}
});

export const getEmailTemplateById = createAsyncThunk('emailTemplates/getById', async (id) => {
	try {
		const response = await axiosInstance.get(`/email-templates/${id}`);
		return response.data;
	} catch (error) {
		throw new Error(error.response?.data?.message);
	}
});

export const createEmailTemplate = createAsyncThunk('emailTemplates/create', async (data) => {
	try {
		const response = await axiosInstance.post('/email-templates', data);
		return response.data;
	} catch (error) {
		throw new Error(error.response?.data?.message);
	}
});

export const updateEmailTemplate = createAsyncThunk('emailTemplates/update', async ({ id, data }) => {
	try {
		const response = await axiosInstance.put(`/email-templates/${id}`, data);
		return response.data;
	} catch (error) {
		throw new Error(error.response?.data?.message);
	}
});

export const searchEmailTemplateUsers = createAsyncThunk(
	'emailTemplates/searchUsers',
	async ({ search = '', page = 0, size = 20 } = {}) => {
		try {
			const params = new URLSearchParams({ page, size });
			if (search) params.set('search', search);
			const response = await axiosInstance.get(`/email-templates/recipients/search?${params}`);
			return response.data;
		} catch (error) {
			throw new Error(error.response?.data?.message || 'Error searching users');
		}
	},
);

export const getEmailTemplateVariables = createAsyncThunk('emailTemplates/getVariables', async () => {
	try {
		const response = await axiosInstance.get('/email-templates/variables');
		return response.data;
	} catch (error) {
		throw new Error(error.response?.data?.message || 'Error fetching template variables');
	}
});

export const deleteEmailTemplate = createAsyncThunk('emailTemplates/delete', async (id) => {
	try {
		await axiosInstance.delete(`/email-templates/${id}`);
		return id;
	} catch (error) {
		throw new Error(error.response?.data?.message);
	}
});

const emailTemplateSlice = createSlice({
	name: 'emailTemplates',
	initialState,
	reducers: {},
	extraReducers: {
		[getAllEmailTemplates.pending]: (state) => { state.emailTemplates.loading = true; },
		[getAllEmailTemplates.fulfilled]: (state, action) => {
			state.emailTemplates.loading = false;
			state.emailTemplates.list = action.payload;
		},
		[getAllEmailTemplates.rejected]: (state) => { state.emailTemplates.loading = false; },

		[getEmailTemplateById.pending]: (state) => { state.selectedTemplate.loading = true; },
		[getEmailTemplateById.fulfilled]: (state, action) => {
			state.selectedTemplate.loading = false;
			state.selectedTemplate.template = action.payload;
		},
		[getEmailTemplateById.rejected]: (state) => { state.selectedTemplate.loading = false; },

		[createEmailTemplate.fulfilled]: (state, action) => {
			state.emailTemplates.list.push(action.payload);
		},

		[updateEmailTemplate.fulfilled]: (state, action) => {
			state.emailTemplates.list = state.emailTemplates.list.map((t) =>
				t.id === action.payload.id ? action.payload : t,
			);
		},

		[deleteEmailTemplate.fulfilled]: (state, action) => {
			state.emailTemplates.list = state.emailTemplates.list.filter((t) => t.id !== action.payload);
		},

		[getEmailTemplateVariables.pending]: (state) => { state.templateVariables.loading = true; },
		[getEmailTemplateVariables.fulfilled]: (state, action) => {
			state.templateVariables.loading = false;
			state.templateVariables.catalog = action.payload;
		},
		[getEmailTemplateVariables.rejected]: (state) => { state.templateVariables.loading = false; },
	},
});

export default emailTemplateSlice.reducer;
